import React, { SVGProps } from 'react';

const ContractSpecificationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    data-palette="ContractSpecificationIcon">
    <path
      d="M0.666748 1.3275C0.668273 1.10865 0.755832 0.899181 0.910509 0.744348C1.06519 0.589515 1.27456 0.501746 1.49341 0.5H16.5067C16.9634 0.5 17.3334 0.870833 17.3334 1.3275V14.6725C17.3319 14.8914 17.2443 15.1008 17.0897 15.2557C16.935 15.4105 16.7256 15.4983 16.5067 15.5H1.49341C1.27409 15.4998 1.06383 15.4125 0.908823 15.2573C0.753816 15.1022 0.666748 14.8918 0.666748 14.6725V1.3275ZM8.16675 2.16667H2.33341V13.8333H8.16675V2.16667ZM9.83342 2.16667V13.8333H15.6667V2.16667H9.83342ZM10.6667 3.83333H14.8334V5.5H10.6667V3.83333ZM10.6667 6.33333H14.8334V8H10.6667V6.33333Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth="0.6"
    />
  </svg>
);

export default ContractSpecificationIcon;
